<template>
    <div class="password-input-box">
        <input :type="inputType" v-model="value" :class="classType=='text-input2'?'text-input2':'text-input'" :placeholder="$attrs.placeholder" :disabled="$attrs.disabled" @input="$emit('update:modelValue', $event.target.value)">
        <span :class="classType=='text-input2'?'password-input-show-btn2':'password-input-show-btn'"  class="password-input-show-btn" @click="inputType = 'text'" v-show="inputType === 'password'"><font-awesome-icon icon="fa-solid fa-eye" /></span>
        <span :class="classType=='text-input2'?'password-input-show-btn2':'password-input-show-btn'"  @click="inputType = 'password'" v-show="inputType !== 'password'"><font-awesome-icon icon="fa-solid fa-eye-slash" /></span>
    </div>

</template>

<script setup>
    import {onMounted, ref, watch} from 'vue'
    import { library } from '@fortawesome/fontawesome-svg-core'
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
    import {faEye, faEyeSlash} from '@fortawesome/free-solid-svg-icons'
    import myUtil from "@/util/util";

    const props = defineProps(['modelValue','classType'])
    const emits = defineEmits(['update:modelValue'])

    //导入图标
    library.add(faEye, faEyeSlash)
    const inputType = ref("password")

    const value = ref(null)

    const classType = ref("text-input")

    watch(() => props.modelValue, (newValue, oldValue) => {
        value.value = newValue
    })

    onMounted(() => {
        value.value = props.modelValue
      if (myUtil.isNotEmpty(props.classType)){
          classType.value = props.classType
      }
    })
</script>

<style scoped>
    .password-input-box {
        position: relative;
    }

    .text-input {
        margin-top: 10px;
        margin-bottom: 10px;
        width: 100%;
        height: 35px;
        border-bottom: 1px #888888 solid;
        border-top: 0 #000000 solid;
        border-left: 0 #000000 solid;
        border-right: 0 #000000 solid;
        outline: 0;
      background: transparent;
    }
    .text-input2 {
      margin-top: 10px;
      margin-bottom: 10px;
      width: 100%;
      height: 35px;
      border-bottom: 0px #888888 solid;
      border-top: 0 #000000 solid;
      border-left: 0 #000000 solid;
      border-right: 0 #000000 solid;
      outline: 0;
      background: transparent;
      color: #FFFFFF;
    }
    .text-input2::placeholder {
      color: #ffffff;
    }
    .text-input2::-webkit-input-placeholder { /* WebKit, Blink, Edge */
      color: #FFFFFF;
    }
    .text-input2:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
      color: #FFFFFF;
      opacity:  1;
    }
    .text-input2::-moz-placeholder { /* Mozilla Firefox 19+ */
      color: #FFFFFF;
      opacity:  1;
    }
    .text-input2:-ms-input-placeholder { /* Internet Explorer 10-11 */
      color: #FFFFFF;
    }
    .text-input2::-ms-input-placeholder { /* Microsoft Edge */
      color: #FFFFFF;
    }

    .text-input2::placeholder { /* Most modern browsers support this now. */
      color: #FFFFFF;
    }

    .password-input-show-btn {
        position: absolute;
        cursor: pointer;
        font-size: 14px;
        top: 20px;
        right: 0;
        user-select: none;

    }
    .password-input-show-btn {
      position: absolute;
      cursor: pointer;
      font-size: 14px;
      top: 20px;
      right: 0;
      user-select: none;
      color: #FFFFFF;
    }
</style>